import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Breadcrumb from '@/components/feature/Breadcrumb';
import VideoCard from '@/pages/home/components/VideoCard';
import { videos, categories } from '@/mocks/videos';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'movie');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);
  const filteredVideos = videos.filter((v) => v.category === activeCategory);

  return (
    <>
      <SEO
        title={`${currentCategory?.name || '分类'} - 菠萝视频高清在线观看`}
        description={`菠萝视频${currentCategory?.name || '视频'}分类，海量高清${currentCategory?.name || '视频'}内容在线观看，免费流畅播放。`}
        keywords={`菠萝视频,${currentCategory?.name || '视频'},在线观看,高清,免费`}
        canonicalUrl={`https://www.boluovideo.com/category/${activeCategory}`}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', path: '/' },
            { label: currentCategory?.name || '分类' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
                {currentCategory?.name}
              </h1>
              <p className="text-foreground-500">
                共 {filteredVideos.length} 部作品
              </p>
            </div>

            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 bg-background-100 hover:bg-background-200'
                  }`}
                >
                  <span className="w-4 h-4 inline-flex items-center justify-center mr-1.5">
                    <i className={cat.icon}></i>
                  </span>
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredVideos.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
                {filteredVideos.map((video) => (
                  <VideoCard
                    key={video.id}
                    id={video.id}
                    title={video.title}
                    thumbnail={video.thumbnail}
                    rating={video.rating}
                    year={video.year}
                    duration={video.duration}
                    tags={video.tags}
                    views={video.views}
                    isHot={video.isHot}
                    isNew={video.isNew}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-video-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">暂无该分类的视频内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
        <Footer />
      </div>
    </>
  );
}